import { api } from '@mbfab/client-api'
import { isNull, isSome } from '@mbfab/shared'
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { CenteredLoading } from '@/components/app/centered-loading'
import { GraphqlErrorPanel } from '@/components/app/graphql-error-panel'
import { ErrorPanel } from '@/components/ui/error-panel'
import { AdminIdentityProvider } from '@/providers/admin-identity-context'
import { AuthenticatedApolloProvider } from '@/providers/authenticated-apollo-provider'

// admin 配下は特定テナントに紐付かないため tenantId は null
export const Route = createFileRoute('/admin')({
  component: () => (
    <AuthenticatedApolloProvider tenantId={null}>
      <AdminGate />
    </AuthenticatedApolloProvider>
  ),
})

// v1 の layouts/AdminLayout.tsx と同じロールガード。
// バックエンドの admin 系 resolver は throwIfNotAuthorizedOrNotAdmin で守られているので
// ここの目的は防御ではなく、権限が無いことを明示して行き止まりにしないこと
function AdminGate() {
  const navigate = useNavigate()
  const identityQuery = api.useFetchMyIdentityQuery()

  if (identityQuery.loading) {
    return <CenteredLoading message="読み込み中..." />
  }

  if (isSome(identityQuery.error)) {
    return (
      <GraphqlErrorPanel
        error={identityQuery.error}
        subject="管理者情報"
        onRetry={() => {
          void identityQuery.refetch()
        }}
      />
    )
  }

  const myIdentity = identityQuery.data?.myIdentity
  if (isNull(myIdentity)) {
    return <CenteredLoading message="読み込み中..." />
  }

  if (myIdentity.role !== 'admin') {
    return (
      <ErrorPanel
        title="このページにはアクセスできません"
        description="管理者用メニューは Mill-Box の運営メンバーのみが利用できます。"
        action={{
          label: 'テナント選択に戻る',
          icon: ArrowLeft,
          onClick: () => {
            void navigate({ to: '/' })
          },
        }}
      />
    )
  }

  return (
    <AdminIdentityProvider myIdentity={myIdentity}>
      <Outlet />
    </AdminIdentityProvider>
  )
}
